import { AxiosResponse } from "axios";
import {
	getLocationDetails,
	getLocationDetailsKey,
} from "../../services/api.services";
import {
	getLocationFailure,
	getLocationRequested,
	getLocationSuccess,
} from "../slices/location.slice";
import { put, takeLatest, all, call, retry } from "redux-saga/effects";
import { ILocationState } from "../types/location.types";
import { logClientError } from "@/lib/services/client-logger.service";

function* handleFetchLocation(action: any) {
	try {
		let response: AxiosResponse;

		if (action.payload?.rkey) {
			response = yield retry(2, 500, getLocationDetailsKey, action.payload);
		} else {
			response = yield retry(2, 500, getLocationDetails, action.payload);
		}

		const {
			data: { data },
		} = response;

		const locationDetails: ILocationState = {
			pwuserid: data?.pspAccountId,
			locationAddressId: data?.accountAddressId,
			locationName: data.locationName,
			contactEmail: data?.locationEmail,
			contactNumber: data?.pspPhone,
			appInfo: data?.appInfo,
			applicationType: data?.applicationType,
			iconURL:
				"https://www.google.com/url?sa=i&url=https%3A%2F%2Fmyicons.co%2Fmyicons-circle-social-line-icons&psig=AOvVaw0ItbGPpV6QAa16Bnw_SpFq&ust=1763028545047000&source=images&cd=vfe&opi=89978449&ved=0CBUQjRxqFwoTCJip36Sv7JADFQAAAAAdAAAAABAE",
		};
		yield put(getLocationSuccess(locationDetails));
	} catch (error: any) {
		yield put(getLocationFailure(error));

		yield call(logClientError, {
			level: "error",
			event: "mark_location_info_failed",
			message: "Failed to mark location info",
			error,
			context: {
				statusCode: error?.response?.status,
				apiMessage: error?.response?.data?.message,
			},
		});
	}
}

export default function* locationSaga() {
	yield all([takeLatest(getLocationRequested.type, handleFetchLocation)]);
}
